import React from 'react';

interface Props {
  children: React.ReactElement;
}

export const FormTitle = ({ children }: Props) => <h3>{children}</h3>;
